module.exports = __webpack_public_path__ + "static/media/origination-pl.b0b19f42.svg";